import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { makeBoxBuyDisconnectIntegration } from '../../models/Integration/makeBoxBuyIntegration'

function* disconnectBoxBuyIntegration() {
  try {
    const actionNames = fetchActionsName(
      ActionNames.DisconnectBoxBuyIntegration,
    )
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          makeBoxBuyDisconnectIntegration,
        ),
      ),
    ])

    yield call(service)

    yield call(() => window.location.reload())
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(
    IntegrationAction.DisconnectBoxBuyIntegration,
    disconnectBoxBuyIntegration,
  )
}
